import React from "react";

import { Tabs as AntTabs, TabsProps as AntTabsProps } from "antd";

export type TabsProps = AntTabsProps & {
  className?: string;
  dataTestId?: string;
};
export const Tabs = ({ className, dataTestId, ...props }: TabsProps) => {
  // just making sure that the items array doesn't have null values, otherwise this crashes
  const allProps = props || { items: [] };
  const items = allProps.items?.filter((item) => item);

  const tabProps = {
    ...allProps,
    items,
  };

  return <AntTabs moreIcon={null} className={className} data-testid={dataTestId} {...tabProps} />;
};
